import React, { ChangeEvent } from "react";
import { Delete as DeleteIcon } from "@material-ui/icons";
import { Grid, InputAdornment, IconButton } from "@material-ui/core";
import ValidationResult from "../../../hooks/change-tracker/ValidationResult";
import TrTextField from "../../shared/controls/TrTextField";
import { AuthorizedCarrier } from "../../../models/financing-request/AuthorizedCarrier";
import TrackerName from "../../../models/financing-request/FinancingRequestBasicInfoTrackerName";
import {
  nameof,
  getTooltipForDecimalInput,
  getCurrencyDisplayName
} from "../../../utilities/utilities";
import Currency from "../../../models/shared/Currency";

interface Props {
  index: number;
  authorizedCarrier: AuthorizedCarrier;
  validationResult: ValidationResult;
  currency: Currency;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onDelete: (index: number) => void;
}

function AuthorizedCarrierItem({
  index,
  authorizedCarrier,
  validationResult,
  currency,
  onChange,
  onDelete
}: Props) {
  return (
    <Grid container item xs={12} spacing={6} className="noMarginPadding">
      <Grid
        container
        item
        xl={11}
        lg={11}
        spacing={5}
        className="noMarginPadding"
      >
        <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
          <TrTextField
            required
            label="Naziv prijevoznika"
            name={nameof<typeof authorizedCarrier>("name")}
            value={authorizedCarrier.name || ""}
            className="textField"
            onChange={onChange}
            error={
              !validationResult.isArrayPropertyValid(
                TrackerName.AuthorizedCarriers,
                index.toString(),
                nameof<typeof authorizedCarrier>("name")
              )
            }
          />
        </Grid>
        <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
          <TrTextField
            required
            label="Ukupna dnevna kilometraža"
            name={nameof<typeof authorizedCarrier>("dailyMileage")}
            value={authorizedCarrier.dailyMileage || ""}
            type="number"
            tooltip={getTooltipForDecimalInput()}
            className="textField"
            InputProps={{
              endAdornment: <InputAdornment position="end">Km</InputAdornment>
            }}
            onChange={onChange}
            error={
              !validationResult.isArrayPropertyValid(
                TrackerName.AuthorizedCarriers,
                index.toString(),
                nameof<typeof authorizedCarrier>("dailyMileage")
              )
            }
          />
        </Grid>
        <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
          <TrTextField
            required
            label="Cijena po danu"
            name={nameof<typeof authorizedCarrier>("dailyPrice")}
            value={authorizedCarrier.dailyPrice || ""}
            type="number"
            tooltip={getTooltipForDecimalInput()}
            className="textField"
            InputProps={{
              endAdornment: <InputAdornment position="end">{getCurrencyDisplayName(currency)}</InputAdornment>
            }}
            helperText="Ukupna cijena po danu za sve učenike"
            onChange={onChange}
            error={
              !validationResult.isArrayPropertyValid(
                TrackerName.AuthorizedCarriers,
                index.toString(),
                nameof<typeof authorizedCarrier>("dailyPrice")
              )
            }
          />
        </Grid>
        <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
          <TrTextField
            required
            label="Broj učenika"
            name={nameof<typeof authorizedCarrier>("numberOfStudents")}
            value={authorizedCarrier.numberOfStudents || ""}
            type="number"
            className="textField"
            onChange={onChange}
            error={
              !validationResult.isArrayPropertyValid(
                TrackerName.AuthorizedCarriers,
                index.toString(),
                nameof<typeof authorizedCarrier>("numberOfStudents")
              )
            }
          />
        </Grid>
      </Grid>
      <Grid item xl={1} lg={1}>
        <IconButton aria-label="delete" onClick={() => onDelete(index)}>
          <DeleteIcon />
        </IconButton>
      </Grid>
    </Grid>
  );
}

function areEqual(prevProps: Props, nextProps: Props): boolean {
  if (
    prevProps.authorizedCarrier === nextProps.authorizedCarrier &&
    prevProps.validationResult.getTrackerMessages(
      TrackerName.AuthorizedCarriers
    ).length ===
      nextProps.validationResult.getTrackerMessages(
        TrackerName.AuthorizedCarriers
      ).length
  ) {
    return true;
  }
  return false;
}

// Export as memoized component (performance boost)
export default React.memo(AuthorizedCarrierItem, areEqual);
